import { lazy } from 'react';

export const LazyJointVulnerableNewtCopaceticMoaReportPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--joint-vulnerable-newt-copacetic-moa-report-page" */ './joint-vulnerable-newt-copacetic-moa-report-page'
    ),
);
